<template lang="html">

  <section class="mini-site">
    <div id="content">
      <div class="section" id="minisite">
        <div class="container pt-4 pb-4 mb-5">
          <panel-info-evenement :evenementId="evenementId"/>
        </div>
      </div>
      <pied-creer-billetterie/>
    </div>
  </section>

</template>

<script lang="js">
  import PiedCreerBilletterie from '@/components/PiedCreerBilletterie.vue'
  import PanelInfoEvenement from '@/components/PanelInfoEvenement.vue'

  export default  {
    name: 'mini-site',
    props: [
        'evenementId'
    ],
    mounted() {
        
    },
    data() {
      return {
         
      }
    },
    methods: {

    },
    computed: {

    },
    components: {
      PiedCreerBilletterie,
      PanelInfoEvenement
    }
}
</script>

<style>
  .section#minisite .rmajestic
  {
      background-color:#EAEAEA;
      border-radius: 5em;
      padding: .5em;
  }

  .section#minisite .rmajestic  img
  {
      width: 2em;
      height: 2em;

  }

  .section#minisite
  {
      background-image: url(../assets/img/cinema_background.jpg);
      background-repeat: no-repeat;
      background-size: 100% 50% ;
      background-position-y: over;
      
  }

  .section#minisite .container
  {
      background-color: #ffffff;
      border: 0.1em solid;
      border-color: #EAEAEA;
  }

  .section#minisite .prix
  {
      font-weight: bold;
  }
  hr 
  {
      margin-top: 1rem;
      margin-bottom: 1rem;
      border: 0;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  .section#minisite .ipaiement
  {
      background-color: #E0E0E0;
      min-height: 20em;
      margin: 0em;
  }

  .section#minisite .other
  {
      font-weight: bold;
  }

  .section#minisite .otherfilms
  {
      padding: 2em;
  }


  .section#minisite .sitePicture
  {
      position: relative;
      height: 100%;
  }

  .section#minisite .sitePicture .picturebg
  {
      position:absolute;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;

  }

  .section#minisite h4{
      margin-bottom: 1em;
  }
  .section#minisite .siteinfo
  {
      min-height: 22em;
  }

  .section#minisite .siteinfo>.row:first-child
  {
      min-height: 22em;
  }

  .section#minisite .sitePicture .overlay
  {
      position: absolute;
      background-color: rgba(1, 25, 56, 0.81);
      width: 100%;
      height: 100%;
      object-fit: contain;
  }

  .section#minisite .sitePicture .overlay img
  {
      text-align: center;
      height: 100%;
  }

  .rmajestic p
  {
      margin-bottom: 0;
  }
  .siteinfo #designation{
      padding: .1rem .5rem;
      font-size: xx-small;
  }
  .section#minisite .rmajestic img {
      width: 1.5em;
      height: 1.5em;
      margin-right: .4em;
  }
  .section#minisite .rmajestic p{
      max-width: 350px;
  }


  @media (max-width: 575.98px) {
      
      
      

  }
  
  @media (min-width: 768px) and (max-width: 991.98px) { 
      #buy-Btn, #share-Btn {
        font-size: xx-small;
      }
  }


</style>
